<template>
	<div class="long_products_page">
		<!-- 顶部标题�?-->
		<div class="page_header">
			<div class="back_btn" @click="$router.go(-1)">
				<img src="../../../src/assets/images/return.png" alt="">
			</div>
			<div class="page_title"> {{ $t('index.title') }}</div>
		</div>

		<!-- 长期产品列表 -->
		<div class="products_list">
			<div class="product_item" v-for="item in productList" @click="goToProduct(item.id)">
				<div class="product_icon red_icon">
					<img :src="item.img" alt="">
				</div>
				<div class="product_info">
					<div class="product_name">{{ item[lang] }}</div>
				</div>
				<div class="arrow_icon">
					<img src="../../../src/assets/images/goto.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';
export default {
	name: "LongProducts",
	lang: null,
	data() {
		return {
			// 页面数据
			productList: [],
			loading: false
		};
	},
	methods: {
		goToProduct(productType) {
			// 跳转到项目详情页面
			this.$router.push('/projectDetail');
		},
		// 获取产品列表
		async getProductList() {
			try {
				this.loading = true;
				const result = await Fetch('/index/item_search', { lang: this.lang, id: this.$route.query.id });
				
				if (result.code === 1 && result.data && result.data.list) {
					this.productList = result.data.list;
					console.log(this.productList);
				} else {
					console.error('获取产品列表失败:', result);
				}
			} catch (error) {
				console.error('请求产品列表出错:', error);
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {
		console.log(this.$route.query.id);
		this.getProductList();
		this.lang = localStorage.getItem('lang');
	}
};
</script>

<style lang="less" scoped>
.long_products_page {
	// min-height: 100vh;
	background-color: #f7f7f7;
}

.page_header {
	position: relative;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;

	.back_btn {
		position: absolute;
		left: 16px;
		height: 44px;
		display: flex;
		align-items: center;
		cursor: pointer;
		
		img {
			width: 16px;
		}
	}

	.page_title {
		font-size: 16px;
		color: #000;
		font-weight: 500;
	}
}

.products_list {
	padding: 10px;

	.product_item {
		display: flex;
		align-items: center;
		padding: 16px;
		background: #fff;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		}

		.product_icon {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 16px;
			
			img {
				width: 100%;
				height: 100%;
			}
		}

		.product_info {
			flex: 1;
			display: flex;

			.product_name {
				font-size: 14px;
				color: #323233;
				font-weight: 500;
			}
		}

		.arrow_icon {
			color: #ccc;
			margin-left: 8px;
			
			img {
				width: 16px;
			}
		}
	}
}
</style> 
